var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pause_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pause_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85 0A2.15 2.15 0 0 1 6 2.15v19.7A2.15 2.15 0 0 1 3.85 24h-1.7A2.15 2.15 0 0 1 0 21.85V2.15A2.15 2.15 0 0 1 2.15 0h1.7Zm10.364 0a2.15 2.15 0 0 1 2.15 2.15v19.7a2.15 2.15 0 0 1-2.15 2.15h-1.7a2.15 2.15 0 0 1-2.15-2.15V2.15A2.15 2.15 0 0 1 12.514 0h1.7Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pause_svg__a)",
    transform: "translate(-167 -102)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pause_svg__b)",
    transform: "translate(167 102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.364v24H0V0z"
  })))));
};

export default SvgPause;